module.exports = __webpack_public_path__ + "static/media/facebook.65ba4750.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/ShareProfile/facebook.svg
// module id = 332
// module chunks = 0